import { States } from '@yandex-360/telemost-sdk/audio-diagnostics';

type GetInputDiagnosticBtnTitleFunction = (state: States, isHovered?: boolean) => string;

export const getInputDiagnosticBtnTitle: GetInputDiagnosticBtnTitleFunction = (state, isHovered = true) => {
    const states = {
        idle: 'diagnostic-record-btn',
        recording: isHovered ? 'diagnostic-stop-record-btn' : 'diagnostic-input-recording-btn',
        playing: isHovered ? 'diagnostic-stop-playing-btn' : 'diagnostic-playing-record',
        destroyed: 'diagnostic-record-btn',
    };

    return states[state];
};
